import { IGlobal } from "config/config.interface";

function getConfig() {
  return (global as any as IGlobal).config;
}

export function shouldRedirectToParticipantExperience(
  userType?: number,
  assessmentPqp?: number,
  submitRedirectUrl?: string
): boolean {
  const config = getConfig();
  if (!config.PEEnabled || !config.URL_PARTICIPANT_EXPERIENCE) {
    return false;
  }

  if (submitRedirectUrl?.trim()) {
    return false;
  }

  const isParticipant = userType === config.USER_TYPE_PARTICIPANT;
  const hasAssessmentRedirect = assessmentPqp != null && assessmentPqp !== 0;
  return isParticipant || hasAssessmentRedirect;
}

export function getParticipantExperienceUrl(path?: string): string {
  const base = getConfig().URL_PARTICIPANT_EXPERIENCE.replace(/\/$/, "");
  if (!path) {
    return base;
  }
  return `${base}${path.startsWith("/") ? path : `/${path}`}`;
}

export function redirectToParticipantExperience(path?: string): boolean {
  if (!getConfig().PEEnabled || !getConfig().URL_PARTICIPANT_EXPERIENCE) {
    return false;
  }

  const target = getParticipantExperienceUrl(path);
  try {
    if (new URL(target, window.location.origin).origin === window.location.origin) {
      return false;
    }
  } catch {
    return false;
  }

  window.location.href = target;
  return true;
}
